import { css } from 'styled-components';

export const SessionExpiredContent = css(({ theme }) => {
  return css`
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
    gap: 20px;

    > .technical-issue-icon {
      width: 170px;
      height: 100px;
    }

    > .text {
      text-align: center;
      margin: 0 8px;
      color: ${theme.colors.primaryDeepBlue};
    }

    > .title {
      font-weight: 700;
      font-size: 21px;
      line-height: normal;

      @media only screen and ${theme.device.tablet} {
        font-weight: 600;
        font-size: 25px;
        line-height: 30px;
      }
    }

    > .subtitle {
      font-weight: 500;
      font-size: 16px;
      line-height: 21px;
      white-space: pre-line;
    }

    > .description {
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      margin-top: 8px;
    }

    > .page-button {
      margin-top: 39px;
      width: 246px;

      > .button-label {
        font-weight: 700;
        font-size: 14px;
        line-height: 21px;
        margin-left: 6px;
      }
    }
  `;
});
